<template>
  <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16 3.2H0V0H16V3.2ZM16 10.8H0V7.6H16V10.8Z" fill="#010101"/>
  </svg>
 </template>